module.exports = __webpack_public_path__ + "static/media/selo-prata-de-inovacao.a82ca189.png";